import { render, staticRenderFns } from "./LevelFiveTab.vue?vue&type=template&id=547cd204"
import script from "./LevelFiveTab.vue?vue&type=script&lang=js"
export * from "./LevelFiveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports